import { GOOGLE_CLICK_ID_NAME } from '../constants';

export const getGoogleClickIdFromURL = (): string => {
  const regex = new RegExp(`[?&]${GOOGLE_CLICK_ID_NAME}=([^&#]*)`);
  const results = regex.exec(window.location.search);

  return results ? decodeURIComponent(results[1]) : '';
};
